import * as React from 'react';
export const IcInfinity = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19.75 9.19c-1.65-1.56-4.32-1.56-5.96-.02L9 13.72c-.98.93-2.61.93-3.6-.02-.47-.45-.74-1.06-.74-1.71 0-.65.26-1.26.76-1.71.98-.93 2.61-.93 3.6.02l.71.68c.31.3.8.3 1.11 0 .34-.32.34-.85 0-1.17l-.67-.64c-1.63-1.55-4.3-1.56-5.94-.02-1.63 1.56-1.65 4.12 0 5.68.8.76 1.84 1.17 2.97 1.17 1.13 0 2.2-.41 2.99-1.17l4.79-4.55c.98-.93 2.61-.93 3.6.02.98.95.98 2.48-.02 3.42-.98.93-2.61.93-3.6-.02l-.71-.68c-.31-.3-.8-.3-1.11 0-.34.32-.34.85 0 1.17l.65.62c.8.76 1.87 1.19 2.99 1.19s2.18-.41 2.97-1.17c.8-.76 1.23-1.76 1.25-2.82a3.939 3.939 0 00-1.25-2.82z'
      fill='currentColor'
    />
  </svg>
);
